import { SearchArea } from './search-area';

export class SearchAreas {
  constructor(public areas: SearchArea[]) {}

  exists(): boolean {
    return this.areas.length >= 1;
  }

  eq(other: SearchAreas): boolean {
    if (this.areas.length !== other.areas.length) {
      return false;
    }
    return this.areas.every((v, i) => v.eq(other.areas[i]));
  }

  findByKey(key: string): SearchArea | null {
    const found = this.areas.find(area => {
      return area.key === key;
    });

    if (!found) {
      return null;
    }

    return found;
  }

  *[Symbol.iterator](): IterableIterator<SearchArea> {
    for (const v of this.areas) {
      yield v;
    }
  }
}
